import { Router } from "@reach/router";
import MenuPage from "./pages/menu.page";
import OrderPage from "./pages/order.page";
import OrdersPage from "./pages/orders.page";
import "./App.css";
import { Toaster } from "react-hot-toast";
import axios from "axios";

function App() {
  axios.interceptors.request.use(
    function (config) {
      config.headers["Authorization"] =
        `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjMyNTEyMjEyMTI1LCJjaGVjayI6dHJ1ZSwiaWF0IjoxNjE3OTkyNTc3fQ.3orRXP730nT66LSMztyQzcrW4nzDSbUdT4wHrlvv6Ao`;
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  return (
    <>
      <div>
        <Toaster
          containerStyle={{
            zIndex: 999999,
            fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
          }}
        />
      </div>
      <Router>
        <OrdersPage path="/" />
        <OrderPage path="/order/" />
        <OrderPage path="/order/:id/:type" />
        <MenuPage path="/menu" />
      </Router>
    </>
  );
}

export default App;
